import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PurchaseList } from "./purchases/List";
import { PurchaseShow } from "./purchases/Show";
import { PurchaseNew } from "./purchases/New";
import { PurchaseNewSuccess } from "./purchases/NewSuccess";
import { ShoppingListIndex } from "./shopping_lists/Index";
import { ShoppingListShow } from "./shopping_lists/Show";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Login } from "./auth/Login";
import { AuthProvider } from "./auth/AuthContext";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { Dash } from "./dash/Dash";
import { Home } from "./landing/Home";
import { InstallOrLogin } from "./components/InstallOrLogin";
import { OfflineIndicator } from "./components/OfflineIndicator";
import { usePWAInstall } from "./utils/usePWAInstall";
import { ToastProvider } from "./components/Toast";
import { LogOut } from "./auth/Logout";

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
if (!googleClientId) {
  throw new Error("missing REACT_APP_GOOGLE_CLIENT_ID");
}

function App() {
  const install = usePWAInstall();

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <ToastProvider>
        <div className="App h-full">
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route
                  path="/dash/pre-login"
                  element={<InstallOrLogin installApp={install.installApp} />}
                />
                <Route path="/dash/login" element={<Login />} />
                <Route path="/dash/logout" element={<LogOut />} />
                <Route
                  path="/dash"
                  element={<ProtectedRoute installApp={install.installApp} />}
                >
                  <Route path="purchases/new" element={<PurchaseNew />} />
                  <Route
                    path="purchases/new/success"
                    element={<PurchaseNewSuccess />}
                  />
                  <Route
                    path="purchases/pending"
                    element={<PurchaseList status="created" />}
                  />
                  <Route path="purchases/:id" element={<PurchaseShow />} />
                  <Route
                    path="purchases"
                    element={<PurchaseList status="loaded" />}
                  />
                  <Route
                    path="shopping-lists/:id"
                    element={<ShoppingListShow />}
                  />
                  <Route
                    path="shopping-lists"
                    element={<ShoppingListIndex />}
                  />
                  <Route index element={<Dash />} />
                </Route>
                <Route path="/" element={<Home />} />
              </Routes>
            </BrowserRouter>
            <OfflineIndicator />
          </AuthProvider>
        </div>
      </ToastProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
